import React from 'react';
import { required, fetchUtils, SelectInput, NumberInput, Drawer, Button, TextInput, BooleanInput, FormDataConsumer } from 'react-admin';
import SaveIcon from '@material-ui/icons/Save';
const fetch = fetchUtils.fetchJson;

export const UserReportsForm = (props) => {
  let parent = props.parent;
  let state = parent.state;
  let type = props.type;
  function handleSaveReport (props, formData) {
    function updateState(obj, headers, json) {
      obj.setState({saving: false, loading: false});
      if (json.id) obj.setState({code: json.id});
    }
    parent.setState({ loading: true });
    let url = window.nobid_endpoint+'/user_reports?';
    let options = {headers: new Headers()};
    options.headers.set('accept', 'application/json');
    options.headers.set('content-type', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    options.method = 'POST';
    let d = JSON.parse(JSON.stringify(parent.state));
    delete d.data;
    delete d.saved_data;
    delete d.params;
    delete d.saving;
    delete d.loading;
    delete d.listing;
    delete d.perPage;
    delete d.metric_filter;
    
    if (parent.refs && parent.refs.metricFilter) d.metric_filter = parent.refs.metricFilter.state.data;

    d.type=type;
    options.body = JSON.stringify({report_info: d});
    
    fetch(url, options).then(({ headers, json }) => (
      updateState(parent, headers, json)
    ))
  }
  return (
      <div>
      <div style={{textAlign:'center', paddingTop: '40px'}}>Save Report</div>
      <div style={{paddingLeft: '20px', paddingTop: '40px'}}>
      <TextInput label='Report Name' source='report_name' 
      onChange={value => parent.setState({report_name:value.target.value})}
      format={() => {return state.report_name;}}
      style={{width: '90%'}} validate={[required()]}/>
      
      <BooleanInput label='Daily Alert' source='schedule' 
      onChange={ (value) => {parent.setState({schedule: value});} }
      format={() => {return state.schedule;}} />

      <FormDataConsumer> 
        {({ formData }) => (formData.schedule || state.schedule) &&
          <div>
          <hr/>
          Number of records
          <br/>
          <SelectInput label='Is' source='schedule_operator' 
              choices={[{ id: 'eq', name: 'Equals' },{ id: 'gt', name: 'Greater than' },{ id: 'lt', name: 'Less than' }]} 
              onChange={value => parent.setState({schedule_operator:value.target.value})}
              format={() => {return state.schedule_operator;}}/>
          <br/>
          <NumberInput label='Value' source='schedule_value' 
              onChange={value => parent.setState({schedule_value:value.target.value})}
              format={() => {return state.schedule_value;}}
              step={1}
              />
          <br/>
          <TextInput label='Emails Recipients (comma separated)' source='schedule_emails' 
              onChange={value => parent.setState({schedule_emails:value.target.value})}
              format={() => {return state.schedule_emails;}}
              style={{width: '90%'}}/>
          <hr/>
          </div>
        }
      </FormDataConsumer>

      </div>
      <div style={{paddingLeft: '20px'}}>

      <FormDataConsumer>
            {({ formData }) => 
                <Button label="Save Report" props={this} variant="contained" 
                onClick={(e)=> handleSaveReport(e, formData)}
                color="primary" startIcon={<SaveIcon />} disabled={state.loading}/>
            }
      </FormDataConsumer>

      </div>
      <div style={{paddingLeft: '20px'}}>
        <Button label='Cancel' onClick={value => parent.setState({saving: false})} />
      </div>
      </div>
  )
};